module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":"Login","ssoLoginFailed":"SSO login failed"},"de":{"login":"Anmelden","ssoLoginFailed":"SSO-Anmeldung fehlgeschlagen"}}')
  delete Component.options._Ctor
}
